/**
 * i18n configuration — bilingual EN/DE.
 *
 * - Default locale: German (de). The target audience is German-speaking
 *   bookkeepers and their Austrian/German SME clients.
 * - Cookie-based locale selection: no URL prefix, no route reorganization
 *   needed. The language switcher writes `NEXT_LOCALE` and reloads.
 * - Translations live in /git/bookkeeping-automation/frontend/messages/{de,en}.json.
 */

export const LOCALES = ['de', 'en'] as const;
export type Locale = (typeof LOCALES)[number];

export const DEFAULT_LOCALE: Locale = 'de';
export const LOCALE_COOKIE = 'NEXT_LOCALE';

export const LOCALE_LABEL: Record<Locale, string> = {
  de: 'Deutsch',
  en: 'English',
};

export function isLocale(value: string | undefined | null): value is Locale {
  return value === 'de' || value === 'en';
}
